<div
    [class]="setStyleFlag() ? 'bg-primary' : 'bg-white'"
    class="relative px-4 py-3 flex w-full justify-between gap-2.5 rounded-xl"
>
    @if (!completenessError()) {
        @if (open()) {
            <app-chat-tooltip
                animate.leave="fade-out"
                (close)="open.set(false)"
                disableClose
                class="absolute bottom-[calc(100%+12px)]"
            >
                오른쪽 상단에 파란색 '템플릿 등록'을 클릭해주세요<br />
                <span class="text-xs text-[#ffcc33]"
                    >(“템플릿 등록” 버튼이 보이지 않는다면, 센터 완성도 창을
                    닫아주세요.)</span
                >
            </app-chat-tooltip>
        }
    }
    @if (!open() && completenessError() === "1") {
        <app-chat-tooltip
            disableClose
            animate.leave="fade-out"
            (close)="open.set(false)"
            class="absolute bottom-[calc(100%+12px)]"
        >
            서비스 템플릿을 먼저 등록해주세요
        </app-chat-tooltip>
    }
    <div class="flex gap-2.5 items-center">
        <p
            class="text-sm lg:text-base"
            [class]="setStyleFlag() ? 'text-white' : 'text-gray-800'"
            [class.!text-gray-400]="completeness()?.createService"
        >
            서비스 등록
        </p>
        @if (completeness()?.createService) {
            <div class="badge bg-gray-400">완료</div>
        } @else {
            <div
                class="badge"
                [class]="
                    setStyleFlag()
                        ? 'bg-white !text-gray-800'
                        : 'text-white bg-primary'
                "
            >
                등록 필요
            </div>
        }
    </div>
    <div
        routerLink="/center/template/ticket"
        class="flex gap-2 items-center cursor-pointer"
    >
        @if (completeness()?.createService) {
            <p class="text-gray-400 text-sm lg:block hidden">등록완료</p>
        } @else {
            <p
                [class]="setStyleFlag() ? 'text-white' : 'text-gray-400 '"
                class="text-sm"
            >
                등록하기
            </p>
        }
        <app-icon
            name="material-symbols:arrow-forward-ios"
            class="!size-3.5 text-gray-300"
        />
    </div>
</div>
